import Enum from '../../models/base/Enum';

export default class FilterType extends Enum {}

FilterType.array = new FilterType('ARRAY');
FilterType.boolean = new FilterType('BOOLEAN');
FilterType.dateRange = new FilterType('DATE_RANGE');
FilterType.driverId = new FilterType('DRIVER_ID');
FilterType.singleValue = new FilterType('SINGLE_VALUE');
